import { render, staticRenderFns } from "./NumValuePn.vue?vue&type=template&id=61dc1436&"
import script from "./NumValuePn.vue?vue&type=script&lang=js&"
export * from "./NumValuePn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports